import { render, staticRenderFns } from "./CarouselAccount.vue?vue&type=template&id=68a7e796&scoped=true&"
import script from "./CarouselAccount.vue?vue&type=script&lang=js&"
export * from "./CarouselAccount.vue?vue&type=script&lang=js&"
import style0 from "./CarouselAccount.vue?vue&type=style&index=0&id=68a7e796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7e796",
  null
  
)

export default component.exports